var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../icon/Icon.js';
const CHECK_ICON = html `<basic-icon class="check" name="check" size="12"></basic-icon>`;
let SimpleList = class SimpleList extends LitElement {
    constructor() {
        super(...arguments);
        this.items = [];
        this.selected = null;
    }
    _onSelect(item) {
        this.dispatchEvent(new CustomEvent('select', {
            detail: { value: item.value, item },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        return html `
      <div class="menu" role="menu">
        ${this.heading
            ? html `<div class="menu-title">${this.heading}</div>`
            : ''}
        ${this.items.map((item) => {
            const active = item.value === this.selected;
            return html `
            <button
              class="option ${active ? 'is-active' : ''}"
              type="button"
              role="menuitemradio"
              aria-checked=${active}
              @click=${() => this._onSelect(item)}
            >
              <span class="option-label">${item.label}</span>
              ${CHECK_ICON}
            </button>
          `;
        })}
      </div>
    `;
    }
};
SimpleList.styles = css `
    :host {
      display: block;
      font-family: inherit;
    }

    .menu {
      min-width: 180px;
      max-height: 320px;
      overflow-y: auto;
      padding: 4px;
      background: #fff;
      border: 1px solid #d0d7de;
      border-radius: 8px;
      box-shadow:
        0 6px 20px rgba(0, 0, 0, 0.12),
        0 2px 4px rgba(0, 0, 0, 0.05);
      display: flex;
      flex-direction: column;
      font-size: 12.5px;
      box-sizing: border-box;
    }

    .menu-title {
      font-size: 10.5px;
      font-weight: 600;
      color: #8a95a5;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      padding: 6px 10px 4px;
    }

    .option {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 7px 10px;
      background: none;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      font-family: inherit;
      font-size: 12.5px;
      color: #333;
      text-align: left;
      width: 100%;
    }
    .option:hover {
      background: #f4f7fa;
    }
    .option.is-active {
      background: #f2f6fa;
    }

    .option-label {
      flex: 1;
      text-align: left;
    }

    .check {
      color: #0078d4;
      flex-shrink: 0;
      visibility: hidden;
    }
    .option.is-active .check {
      visibility: visible;
    }

    /* Thin scrollbar matching the platform's toolbar menus. */
    .menu {
      scrollbar-width: thin;
      scrollbar-color: #cbd5e1 transparent;
    }
    .menu::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    .menu::-webkit-scrollbar-track {
      background: transparent;
    }
    .menu::-webkit-scrollbar-thumb {
      background: #cbd5e1;
      border-radius: 3px;
    }
    .menu::-webkit-scrollbar-thumb:hover {
      background: #94a3b8;
    }
  `;
__decorate([
    property({ type: Array })
], SimpleList.prototype, "items", void 0);
__decorate([
    property({ type: String })
], SimpleList.prototype, "heading", void 0);
__decorate([
    property({ attribute: false })
], SimpleList.prototype, "selected", void 0);
SimpleList = __decorate([
    customElement('simple-list')
], SimpleList);
export { SimpleList };
//# sourceMappingURL=SimpleList.js.map